import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">推荐漫画</h2>
          <p className="text-sm text-foreground-500 mb-8">编辑精选的高分漫画作品推荐</p>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
            {cardItems.map((item, i) => (
              <div
                key={i}
                className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-[3/4] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading={i >= 3 ? 'lazy' : undefined}
                  />
                  <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-medium bg-primary-500 text-background-50 rounded-full whitespace-nowrap">
                    {item.badge}
                  </span>
                </div>
                <div className="p-3">
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5 truncate">{item.desc}</p>
                  <p className="text-xs text-foreground-400 mt-1.5">{item.category}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}